import { Injectable, signal } from '@angular/core';
import { Network } from '@capacitor/network';
import { environment } from '@env/environment';
import * as Sentry from '@sentry/capacitor';

@Injectable()
export class NetworkService
{
    isOnline = signal<boolean>(false);

    async initialize()
    {
        // for testing purposes only
        if (!environment.production && !environment.isOnline)
        {
            this.isOnline.set(false);

            return;
        }

        const result = await Network.getStatus();
        this.isOnline.set(result.connected);

        Sentry.addBreadcrumb({
            category: 'network',
            message: `Network status initialized: ${result.connected ? 'online' : 'offline'}`,
            level: 'info',
        });

        await Network.addListener('networkStatusChange', (status) =>
        {
            console.log('networkStatusChange', status);

            this.isOnline.set(status.connected);

            Sentry.addBreadcrumb({
                category: 'network',
                message: `Network status changed to: ${status.connected ? 'online' : 'offline'}`,
                level: 'info',
            });
        });
    }
}
